<template>
  <v-sheet :height="this.$root.windowHeight">
    <v-container class="fill-height" v-if="!details">
      <v-row justify="center">
        <v-col xs="3" sm="3" lg="3" md="3" xl="2" cols="11">
          <v-row justify="center">
            <v-col align="center">
              <h1>
                En un simple número
              </h1>
            </v-col>
          </v-row>
          <v-row justify="center">
            <apexchart type="radialBar" height="350" :options="chartOptions" :series="series"></apexchart>
            <p>
              <v-card class="mt-5 hidden-xs-only" min-width="300" align="center">
                <v-card-text>
                  {{ Math.floor(minutes / 1440) }} días con {{ Math.floor((minutes % 1400) / 60) }} horas y {{ Math.floor((minutes % 1400) % 60) }} minutos
                </v-card-text>
              </v-card>
              <v-card class="mt-5 hidden-sm-and-up" min-width="200" align="center">
                <v-card-text>
                  {{ Math.floor(minutes / 1440) }} días con {{ Math.floor((minutes % 1400) / 60) }} horas y {{ Math.floor((minutes % 1400) % 60) }} minutos
                </v-card-text>
              </v-card>
            </p>
          </v-row>
          <v-row justify="center">
            <v-badge color="primary" overlap :content="tc_records.length" :value="tc_records" class="mt-3">
              <v-btn color="#7400b8" icon large outlined @click="details = !details">
                <v-avatar size="40">
                  <v-img src="https://www.themoviedb.org/t/p/original/cc0kXVI82iosBRA7HoG7lVuUeRh.jpg"/>
                </v-avatar>
              </v-btn>
            </v-badge>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="fill-height" v-else>
      <v-row align="center" justify="center">
        <v-col align="center">
          <v-card max-width="400">
            <v-card-title>
              <v-card-actions>
                <v-btn icon outlined @click="details = !details">
                  <v-icon>
                    mdi-keyboard-backspace
                  </v-icon>
                </v-btn>
                <v-card-title>
                  Tu Timmyscore es {{ tc_records.length }}
                </v-card-title>
              </v-card-actions>
            </v-card-title>
            <MovieWall :records="tc_records" v-if="tc_records.length > 0"/>
            <div v-else>
              <v-card-text>
                <v-img :src="meme" max-width="200"/>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>


</template>

<script>
import VueApexCharts from "vue-apexcharts";
import MovieWall from "@/components/MovieWall";

export default {
  name: "Numbers",
  props: ["count", "minutes", "total", "tc_records"],
  components: {
    MovieWall,
    apexchart: VueApexCharts,
  },
  computed: {
    chartOptions: function () {
      return {
        chart: {
          height: 350,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            hollow: {
              size: '60%',
            },
            dataLabels: {
              show: true,
              name: {
                show: false
              },
              value: {
                fontSize: '50px',
                // eslint-disable-next-line no-unused-vars
                formatter: (val) => {
                  return this.count;
                },
              },
            }
          },
        },
        colors: ['#7400b8'],
        labels: ['Películas'],
      }
    }
  },
  data: () => ({
    'details': false,
    meme: require('@/assets/shame.jpg')
  }),
  methods: {
    calculatePercentage() {
      return Math.round((this.count / this.total) * 100)
    }
  },
  created() {
    this.series = [this.calculatePercentage()]
  }

}
</script>

<style scoped>

</style>
